"use strict";

exports.__esModule = true;
exports.stringify = exports.parse = void 0;
var _SheetClip = require("./SheetClip");
exports.parse = _SheetClip.parse;
exports.stringify = _SheetClip.stringify;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/3rdparty/SheetClip/index.js
// module id = 407
// module chunks = 0